import { Box, Button, Grid, InputLabel, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import SunEditor from 'suneditor-react';
import {
  align,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  lineHeight,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
  image,
  link
} from "suneditor/src/plugins";
import 'suneditor/dist/css/suneditor.min.css';
import { sendReminderNotification } from 'api/services/notifications';
import { useMutation, useQuery } from 'react-query';
import { snack } from 'components/toast';
import { getOrganization } from 'api/services/organization';
import { ResType } from 'types';
import { triggerTemplateConfig } from 'data/triggerTemplate';
const MailReminder = ({selectedClients,trigger}) => {
    const navigate = useNavigate();
  
   const [title, setTitle] = useState("");
      const [subject, setSubject] = useState("");
    
      const [content, setContent] = useState('');
  const { data: organizationData, isLoading: isOrganizationLoading }: ResType = useQuery(
      ["organization"],
      getOrganization    );
       const { mutate,isLoading } = useMutation(sendReminderNotification, {
        onSuccess: () => {
    snack.success("Emails sent successfully!");
        navigate("/communication/communication/sendNotifications");
        // navigate("communication/communication/remindersSent")

  },
  onError: () => {
    snack.error("Failed to send emails. Please try again.");
  }
});

const template = triggerTemplateConfig[trigger];

  useEffect(() => {
    if (template) {
      setTitle(template.title);
      setSubject(template.subject);
        setContent(template?.content || '');    
    }
  }, [trigger,template]);
if (!isOrganizationLoading && organizationData?.data?.smtp === null) {
    return (
      <Box p={3}>
        <Typography variant="h6" color="error">
          Please enable SMTP to make use of this feature.
        </Typography>
      </Box>
    );
  }
   
      const handleChange = (content: any) => {
  setContent(content);    
};
const emails = Array.isArray(selectedClients)
    ? selectedClients.map((client: any) => client?.email):'';
 
    const handleSubmit =(e)=>{
          e.preventDefault();

        let clientsArray:any = [];

  if (Array.isArray(selectedClients)) {
    clientsArray = selectedClients;
  } else if (selectedClients?.clients && Array.isArray(selectedClients.clients)) {
    clientsArray = selectedClients.clients;
  } else {
    console.error("selectedClients is not in expected format:", selectedClients);
    return;
  }

  // const recipients = clientsArray.map((c) => c.email);
         if (title.trim().length < 3) {
            return snack.error("Please Enter Valid Template Name");
          }
          if (subject.trim().length < 3) {
            return snack.error("Please Enter Valid Subject");
          }
          // Ensure all required fields are filled
          if (!content.trim()) {
            snack.error("Content is mandatory");
            return;
          }
        const trimmedTitle = title.trim()
//         const recipientss = clientsArray.map((client: any) => ({
//   email: client.email,
//   name: client.display_name,
//   amount: client.dueamount,
//   due_date: client.due_date, // if available
// }));
const recipients = clientsArray.map(client => {
      const {
        email,
        ...rest // include all keys for dynamic placeholders
      } = client;

      return {
        email,
        ...rest
      };
    });

         const payload = {
    
    title:trimmedTitle,
    content: content,
    subject:subject,
    recipients: recipients, 
  };

  mutate(payload);
    }
    let richTextEditorHtml: any;

  return (
    <Box sx={{margin:"10px"}}>
  
      <form>

       <Grid container spacing={2} mt={2} display="flex" flexDirection="column" px={3}>
       <Typography variant="h6" color="primary">Create Email Template</Typography>

          <Box mt= {2}>
          <InputLabel id="title">Template Title *</InputLabel>

          <TextField
            // label="Email Template Title"
            name="title"
            size="small"
            fullWidth
            onChange={(e) => setTitle(e.target.value)}
            value={title}
            required
            sx={{width:"50%"}}
            inputProps={{ minLength: 3, maxLength: 50 }}

          />

          </Box>
                <Box mt= {2}>
                <InputLabel id="subject">Subject *</InputLabel>

<TextField
  // label="subject"
  name="subject *"
  size="small"
  fullWidth
  onChange={(e) => setSubject(e.target.value)}
  value={subject}
  sx={{width:"50%"}}
  required
  inputProps={{ minLength: 3, maxLength: 50 }}

/>
</Box>
             </Grid>
             <Grid sx={{mt:"20px",width:"1000px"}}>
            <div>

              <SunEditor
                setOptions={{
                  height: '200',
                  placeholder: "Enter your text here!!!",
                  defaultStyle:"font-color:red",
                  plugins: [
                    align,
                    font,
                    fontColor,
                    fontSize,
                    formatBlock,
                    hiliteColor,
                    horizontalRule,
                    lineHeight,
                    list,
                    paragraphStyle,
                    table,
                    // template,
                    textStyle,
                    image,
                    link
                  ],
                  buttonList: [
                    ["undo", "redo"],
                    ["font", "fontSize", "formatBlock"],
                    ["paragraphStyle"],
                    [
                      "bold",
                      "underline",
                      "italic",
                      "strike",
                      "subscript",
                      "superscript"
                    ],
                    ["fontColor", "hiliteColor"],
                    ["removeFormat"],
                    "/", // Line break
                    ["outdent", "indent"],
                    ["align", "horizontalRule", "list", "lineHeight"],
                    ["table", "link", "image"]
                  ],
                  formats: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"],
                  font: [
                    "Arial",
                    "Calibri",
                    "Comic Sans",
                    "Courier",
                    "Garamond",
                    "Georgia",
                    "Impact",
                    "Lucida Console",
                    "Palatino Linotype",
                    "Segoe UI",
                    "Tahoma",
                    "Times New Roman",
                    "Trebuchet MS"
                  ]
                }}
                // defaultValue={content}
                setContents={content}

                onChange={handleChange}
                // onImageUploadBefore={handleImageUploadBefore}

              />
               {/* <div style={{ marginTop: 20 }}>
                <h2>Editor Content:</h2>
                <div dangerouslySetInnerHTML={{ __html: content }} />
              </div> */}
          </div>
          </Grid>
          <Box flex={1}>
            <Outlet />
          </Box>
          </form>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                      <Button onClick ={handleSubmit} variant="contained" color="secondary" sx={{mr:32,mt:1}}  disabled={isLoading}>Send Email</Button>
          </Box>
          </Box>
  )
}

export default MailReminder;
